import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from "vue";
import { sessionApiStore } from "@/hooks";
import {
  PasswordInput,
  Typography,
  PanelCard,
  TextButton,
} from "@/components/common";


/**
 * Allows for password updating.
 */
const __default__ = {
  name: "MyAccountView",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const oldPassword = ref("");
const newPassword = ref("");

const isDisabled = computed(() => !oldPassword.value || !newPassword.value);

/**
 * Handles a password edit.
 */
function handleEditPassword(): void {
  sessionApiStore.handleChangePassword(
    {
      oldPassword: oldPassword.value,
      newPassword: newPassword.value,
    },
    {
      onSuccess: () => {
        oldPassword.value = "";
        newPassword.value = "";
      },
    }
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), { title: "Update Password" }, {
    actions: _withCtx(() => [
      _createVNode(_unref(TextButton), {
        label: "Update Password",
        disabled: isDisabled.value,
        outlined: "",
        "data-cy": "button-update-password",
        onClick: handleEditPassword
      }, null, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Typography), {
        el: "p",
        value: "Type in your current password and the new password you would like to set."
      }),
      _createVNode(_unref(PasswordInput), {
        modelValue: oldPassword.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((oldPassword).value = $event)),
        label: "Current Password",
        errors: _unref(sessionApiStore).passwordErrorMessage,
        "data-cy": "input-current-password"
      }, null, 8, ["modelValue", "errors"]),
      _createVNode(_unref(PasswordInput), {
        modelValue: newPassword.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newPassword).value = $event)),
        label: "New Password",
        "data-cy": "input-new-password"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})